import { useContext } from "react";
import CustomModal from "../CustomModal/CustomModal";
import { FBTPreview } from "../../apps/Bundles/FTB/FBTBundle/FBTBundle";
import { AppConfigContext } from "../../context/AppConfigContext";

interface Props_ModalPreviewer {
    open: boolean;
    onClose: () => void;
    bundleConfig: any;
}

const FBTModalPreviewer = ({ open, onClose, bundleConfig }: Props_ModalPreviewer) => {
    const appConfigContext = useContext(AppConfigContext);
    return (
        <CustomModal open={open} title={"Frequently Bought Together Desktop Preview"} onClose={onClose} size={"large"}>
            <div
                style={{
                    padding: "0px 20px",
                }}
            >
                <FBTPreview
                    appConfigContext={appConfigContext}
                    bundleConfig={{
                        ...bundleConfig,
                    }}
                    previewType={2}
                />
            </div>
        </CustomModal>
    );
};

export default FBTModalPreviewer;
